import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Col, Row, Tabs } from "antd";
import "./style.css";
import { useRequiredAccess } from "../../hooks/useRequiredAccess";
import { ORG_TYPES } from "../Common/Constants";
import DeviationMonitor from "./DeviationMonitor";
// import TemperatureAlert from "./Temperature";
import SystemAlarms from "./SystemAlarms";

const Alerts = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(
    location?.state?.tabName || "deviationMonitor"
  );
  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line
  }, []);

  const items = [
    // {
    //   key: "temperatureAlert",
    //   label: "Alerts",
    //   children: <TemperatureAlert selectedTab={selectedTab} />,
    // },
    {
      key: "deviationMonitor",
      label: "Threshold Alerts",
      children: (
        <DeviationMonitor
          selectedTab={selectedTab}
          vehicleDetails={location?.state?.vehicleDetails}
        />
      ),
    },
    {
      key: "systemAlarms",
      label: "System Alarms",
      children: (
        <SystemAlarms
          selectedTab={selectedTab}
          vehicleDetails={location?.state?.vehicleDetails}
        />
      ),
    },
  ];

  const onChangeTab = (key) => {
    setSelectedTab(key);
  };

  return (
    <Row className="alert-screen">
      <Col span={24}>
        <div className="vaBaseMargins">
          <Tabs activeKey={selectedTab} items={items} onChange={onChangeTab} />
        </div>
      </Col>
    </Row>
  );
};

export default Alerts;
